import { useState } from "react";
import { Modal } from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";

// Modo "desaprobar": textarea libre + /desaprobar-servicio-admin
// Modo "recordatorio": pantalla de opciones + /enviar-correo-admin
function ModalCorreo({
    idServicio,
    onDesaprobado,
    proveedor,
    modo = "desaprobar",
    labelBoton = "Correo",
    iconoBoton = "bi-envelope",
    variantBoton = "btn-outline-secondary",
    tituloModal = "Enviar correo",
    descripcionModal = "Se enviará un correo al proveedor.",
}) {
    const [show, setShow]         = useState(false);
    const [vista, setVista]       = useState("opciones"); // "opciones" | "personalizado" | "perfilPersonal"
    const [texto, setTexto]       = useState("");
    const [enviando, setEnviando] = useState(false);

    // Para el modo "desaprobar" (vista "opciones" no aplica)
    const [razon, setRazon] = useState("");

    const nombreP = [proveedor?.nombre, proveedor?.apellido]
        .filter(v => v && v !== "NA")
        .join(" ") || proveedor?.username || "";

    const msgPerfilPersonal =
        `Hola${nombreP ? " " + nombreP : ""}!\n\nNos comunicamos del equipo de Zervicy.\n\nTe informamos que en tu cuenta te hace falta solamente completar tu perfil personal. Si puedes ingresar tus datos en la sección de Mi cuenta > Información personal, una vez lo hagas nos comunicamos contigo para terminar de publicar tu servicio.\n\n¡Estamos para ayudarte!`;

    const handleClose = () => {
        setShow(false);
        setVista("opciones");
        setTexto("");
        setRazon("");
    };

    async function enviarRecordatorio(tipo, mensajePersonalizado = "") {
        try {
            setEnviando(true);
            const res = await axios.post("/enviar-correo-admin", {
                params: { idServicio, tipo, mensajePersonalizado },
            });
            if (res.data.exito) {
                handleClose();
                Swal.fire({ icon: "success", title: "Correo enviado", timer: 2000, showConfirmButton: false });
            } else {
                Swal.fire({ icon: "error", title: "Error", text: res.data.mensaje || "No se pudo enviar el correo.", confirmButtonColor: "var(--azul-logo-fondo)" });
            }
        } catch {
            Swal.fire({ icon: "error", title: "Error", text: "Ocurrió un error al enviar.", confirmButtonColor: "var(--azul-logo-fondo)" });
        } finally {
            setEnviando(false);
        }
    }

    async function enviarDesaprobacion() {
        if (!razon.trim()) return;
        try {
            setEnviando(true);
            const res = await axios.post("/desaprobar-servicio-admin", {
                params: { idServicio, mensajeRevision: razon.trim() },
            });
            if (res.data.exito) {
                handleClose();
                Swal.fire({ icon: "success", title: "Desaprobado", text: "El servicio fue desaprobado y se notificó al proveedor.", confirmButtonColor: "var(--azul-logo-fondo)", timer: 2500, showConfirmButton: false });
                if (onDesaprobado) onDesaprobado(razon.trim());
            } else {
                Swal.fire({ icon: "error", title: "Error", text: res.data.mensaje || "No se pudo desaprobar.", confirmButtonColor: "var(--azul-logo-fondo)" });
            }
        } catch {
            Swal.fire({ icon: "error", title: "Error", text: "Ocurrió un error al desaprobar.", confirmButtonColor: "var(--azul-logo-fondo)" });
        } finally {
            setEnviando(false);
        }
    }

    // ── Tarjeta de opción (igual estilo que modalWhatsapp OpcionBtn) ──────────
    function OpcionBtn({ icono, titulo, descripcion, color = "var(--azul-muy-claro)", colorIcono = "var(--azul-logo-fondo)", onClick }) {
        return (
            <div
                role="button"
                tabIndex={0}
                onClick={onClick}
                onKeyDown={e => e.key === "Enter" && onClick()}
                className="d-flex align-items-start gap-3 p-3 rounded-3 mb-2"
                style={{ background: color, cursor: "pointer", border: "1px solid transparent", transition: "border-color 0.15s" }}
                onMouseEnter={e => e.currentTarget.style.borderColor = "var(--gris-adb5bd)"}
                onMouseLeave={e => e.currentTarget.style.borderColor = "transparent"}
            >
                <div
                    className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
                    style={{ width: 38, height: 38, background: colorIcono + "22" }}
                >
                    <i className={`bi ${icono}`} style={{ color: colorIcono, fontSize: "1rem" }}></i>
                </div>
                <div>
                    <div className="fw-semibold small">{titulo}</div>
                    {descripcion && <div className="text-muted" style={{ fontSize: "0.78rem" }}>{descripcion}</div>}
                </div>
                <i className="bi bi-chevron-right ms-auto text-muted" style={{ fontSize: "0.75rem", marginTop: 2 }}></i>
            </div>
        );
    }

    return (
        <>
            <button
                type="button"
                className={`btn ${variantBoton} btn-sm rounded-3`}
                onClick={() => setShow(true)}
            >
                <i className={`bi ${iconoBoton} me-1`}></i>{labelBoton}
            </button>

            <Modal show={show} onHide={handleClose} centered>
                <Modal.Header closeButton className="border-0 pb-0">
                    <Modal.Title className="fw-bold fs-5">
                        {vista !== "opciones" && modo === "recordatorio" && (
                            <button
                                type="button"
                                className="btn btn-link p-0 me-2 text-dark"
                                style={{ fontSize: "0.9rem" }}
                                onClick={() => setVista("opciones")}
                            >
                                <i className="bi bi-arrow-left"></i>
                            </button>
                        )}
                        {tituloModal}
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body className="pt-2 pb-0">
                    <p className="text-muted small mb-3">{descripcionModal}</p>

                    {/* ── MODO DESAPROBAR ────────────────────────────────── */}
                    {modo === "desaprobar" && (
                        <>
                            <label className="form-label fw-semibold small">Razón de desaprobación</label>
                            <textarea
                                className="form-control rounded-3"
                                rows={4}
                                placeholder="Ej: Las imágenes del servicio no cumplen con los estándares mínimos..."
                                value={razon}
                                onChange={e => setRazon(e.target.value)}
                                maxLength={2000}
                            />
                            <div className="text-end mt-1">
                                <span className="text-muted" style={{ fontSize: "0.75rem" }}>{razon.length}/2000</span>
                            </div>
                        </>
                    )}

                    {/* ── MODO RECORDATORIO — pantalla de opciones ────────── */}
                    {modo === "recordatorio" && vista === "opciones" && (
                        <>
                            <OpcionBtn
                                icono="bi-pencil-square"
                                titulo="Escribir mensaje personalizado"
                                descripcion="Redacta el texto que quieres enviarle al proveedor."
                                color="var(--azul-muy-claro)"
                                colorIcono="var(--azul-bootstrap-cta)"
                                onClick={() => setVista("personalizado")}
                            />
                            <OpcionBtn
                                icono="bi-person-badge"
                                titulo="Te falta solamente el perfil personal"
                                descripcion="Informa que solo necesita completar sus datos personales para publicar."
                                color="var(--verde-fondo-muy-suave)"
                                colorIcono="var(--verde-bootstrap)"
                                onClick={() => setVista("perfilPersonal")}
                            />
                        </>
                    )}

                    {/* ── MODO RECORDATORIO — mensaje personalizado ─────── */}
                    {modo === "recordatorio" && vista === "personalizado" && (
                        <>
                            <label className="form-label fw-semibold small">Tu mensaje</label>
                            <textarea
                                className="form-control rounded-3"
                                rows={6}
                                placeholder="Escribe aquí el mensaje que se enviará al proveedor..."
                                value={texto}
                                onChange={e => setTexto(e.target.value)}
                                maxLength={3000}
                                autoFocus
                            />
                            <div className="text-end mt-1">
                                <span className="text-muted" style={{ fontSize: "0.75rem" }}>{texto.length}/3000</span>
                            </div>
                        </>
                    )}

                    {/* ── MODO RECORDATORIO — perfil personal preview ────── */}
                    {modo === "recordatorio" && vista === "perfilPersonal" && (
                        <div
                            className="rounded-3 p-3 small text-muted"
                            style={{ background: "var(--color-bg-surface-alt)", border: "1px dashed var(--color-border)", whiteSpace: "pre-line" }}
                        >
                            {msgPerfilPersonal}
                        </div>
                    )}
                </Modal.Body>

                <Modal.Footer className="border-0 pt-3">
                    <button
                        type="button"
                        className="btn btn-outline-secondary btn-sm rounded-3"
                        onClick={handleClose}
                        disabled={enviando}
                    >
                        Cancelar
                    </button>

                    {/* Desaprobar */}
                    {modo === "desaprobar" && (
                        <button
                            type="button"
                            className="btn btn-danger btn-sm rounded-3 fw-semibold"
                            onClick={enviarDesaprobacion}
                            disabled={!razon.trim() || enviando}
                        >
                            {enviando
                                ? <><span className="spinner-border spinner-border-sm me-2" role="status" />Enviando...</>
                                : <><i className="bi bi-x-circle me-1"></i>Desaprobar y notificar</>
                            }
                        </button>
                    )}

                    {/* Recordatorio personalizado */}
                    {modo === "recordatorio" && vista === "personalizado" && (
                        <button
                            type="button"
                            className="btn btn-primary btn-sm rounded-3 fw-semibold"
                            onClick={() => enviarRecordatorio("mensajeAdmin", texto)}
                            disabled={!texto.trim() || enviando}
                        >
                            {enviando
                                ? <><span className="spinner-border spinner-border-sm me-2" role="status" />Enviando...</>
                                : <><i className="bi bi-send me-1"></i>Enviar correo</>
                            }
                        </button>
                    )}

                    {/* Recordatorio perfil personal */}
                    {modo === "recordatorio" && vista === "perfilPersonal" && (
                        <button
                            type="button"
                            className="btn btn-success btn-sm rounded-3 fw-semibold"
                            onClick={() => enviarRecordatorio("mensajeAdmin", msgPerfilPersonal)}
                            disabled={enviando}
                        >
                            {enviando
                                ? <><span className="spinner-border spinner-border-sm me-2" role="status" />Enviando...</>
                                : <><i className="bi bi-send me-1"></i>Enviar correo</>
                            }
                        </button>
                    )}
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default ModalCorreo;
